'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { ensureDeviceId, getPendingDeviceId, persistDeviceId, setPendingDeviceId } from '@/lib/deviceTrust';

const PUBLIC_PATH_PREFIXES = ['/login', '/confirm-email', '/forgot-password', '/update-password'];

export default function DeviceTrustBootstrap() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const deviceIdFromQuery = searchParams.get('gpdid')?.trim() || '';

  useEffect(() => {
    if (deviceIdFromQuery) {
      persistDeviceId(deviceIdFromQuery);
      setPendingDeviceId(deviceIdFromQuery);
      return;
    }

    const currentPath = window.location.pathname;
    const isPublicPath = PUBLIC_PATH_PREFIXES.some(
      (prefix) => currentPath === prefix || currentPath.startsWith(`${prefix}/`)
    );

    const pendingDeviceId = getPendingDeviceId();
    if (pendingDeviceId) {
      persistDeviceId(pendingDeviceId);

      if (!isPublicPath) {
        const url = new URL(window.location.href);
        if (!url.searchParams.get('gpdid')) {
          url.searchParams.set('gpdid', pendingDeviceId);
          window.history.replaceState(null, '', url.toString());
        }
      }

      return;
    }

    ensureDeviceId();
  }, [deviceIdFromQuery, pathname, searchParams]);

  return null;
}
